"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * The Jira Cloud platform REST API
 * Jira Cloud platform REST API documentation
 *
 * The version of the OpenAPI document: 1001.0.0-SNAPSHOT-1df5db7255b44a0b9aa806f0b2de7cddb4bbffc9
 * Contact: ecosystem@atlassian.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.AppPropertiesApi = void 0;
const tslib_1 = require("tslib");
const runtime = require("../runtime");
const index_1 = require("../models/index");
/**
 *
 */
class AppPropertiesApi extends runtime.BaseAPI {
    /**
     * Deletes an app\'s property.  **[Permissions](#permissions) required:** Only a Connect app whose key matches `addonKey` can make this request. Additionally, Forge apps can access Connect app properties (stored against the same `app.connect.key`).
     * Delete app property
     */
    addonPropertiesResourceDeleteAddonPropertyDeleteRaw(requestParameters, initOverrides) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            if (requestParameters['addonKey'] == null) {
                throw new runtime.RequiredError('addonKey', 'Required parameter "addonKey" was null or undefined when calling addonPropertiesResourceDeleteAddonPropertyDelete().');
            }
            if (requestParameters['propertyKey'] == null) {
                throw new runtime.RequiredError('propertyKey', 'Required parameter "propertyKey" was null or undefined when calling addonPropertiesResourceDeleteAddonPropertyDelete().');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                // oauth required
                headerParameters["Authorization"] = yield this.configuration.accessToken("OAuth2", []);
            }
            if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
                headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
            }
            const response = yield this.request({
                path: `/rest/atlassian-connect/1/addons/{addonKey}/properties/{propertyKey}`.replace(`{${"addonKey"}}`, encodeURIComponent(String(requestParameters['addonKey']))).replace(`{${"propertyKey"}}`, encodeURIComponent(String(requestParameters['propertyKey']))),
                method: 'DELETE',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.VoidApiResponse(response);
        });
    }
    /**
     * Deletes an app\'s property.  **[Permissions](#permissions) required:** Only a Connect app whose key matches `addonKey` can make this request. Additionally, Forge apps can access Connect app properties (stored against the same `app.connect.key`).
     * Delete app property
     */
    addonPropertiesResourceDeleteAddonPropertyDelete(requestParameters, initOverrides) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            yield this.addonPropertiesResourceDeleteAddonPropertyDeleteRaw(requestParameters, initOverrides);
        });
    }
    /**
     * Deletes a Forge app\'s property.  **[Permissions](#permissions) required:** Only Forge apps can make this request.
     * Delete app property (Forge)
     */
    addonPropertiesResourceDeleteAppPropertyDeleteRaw(requestParameters, initOverrides) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            if (requestParameters['propertyKey'] == null) {
                throw new runtime.RequiredError('propertyKey', 'Required parameter "propertyKey" was null or undefined when calling addonPropertiesResourceDeleteAppPropertyDelete().');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                // oauth required
                headerParameters["Authorization"] = yield this.configuration.accessToken("OAuth2", []);
            }
            if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
                headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
            }
            const response = yield this.request({
                path: `/rest/forge/1/app/properties/{propertyKey}`.replace(`{${"propertyKey"}}`, encodeURIComponent(String(requestParameters['propertyKey']))),
                method: 'DELETE',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.VoidApiResponse(response);
        });
    }
    /**
     * Deletes a Forge app\'s property.  **[Permissions](#permissions) required:** Only Forge apps can make this request.
     * Delete app property (Forge)
     */
    addonPropertiesResourceDeleteAppPropertyDelete(requestParameters, initOverrides) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            yield this.addonPropertiesResourceDeleteAppPropertyDeleteRaw(requestParameters, initOverrides);
        });
    }
    /**
     * Gets all the properties of an app.  **[Permissions](#permissions) required:** Only a Connect app whose key matches `addonKey` can make this request. Additionally, Forge apps can access Connect app properties (stored against the same `app.connect.key`).
     * Get app properties
     */
    addonPropertiesResourceGetAddonPropertiesGetRaw(requestParameters, initOverrides) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            if (requestParameters['addonKey'] == null) {
                throw new runtime.RequiredError('addonKey', 'Required parameter "addonKey" was null or undefined when calling addonPropertiesResourceGetAddonPropertiesGet().');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                // oauth required
                headerParameters["Authorization"] = yield this.configuration.accessToken("OAuth2", []);
            }
            if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
                headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
            }
            const response = yield this.request({
                path: `/rest/atlassian-connect/1/addons/{addonKey}/properties`.replace(`{${"addonKey"}}`, encodeURIComponent(String(requestParameters['addonKey']))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => (0, index_1.PropertyKeysFromJSON)(jsonValue));
        });
    }
    /**
     * Gets all the properties of an app.  **[Permissions](#permissions) required:** Only a Connect app whose key matches `addonKey` can make this request. Additionally, Forge apps can access Connect app properties (stored against the same `app.connect.key`).
     * Get app properties
     */
    addonPropertiesResourceGetAddonPropertiesGet(requestParameters, initOverrides) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const response = yield this.addonPropertiesResourceGetAddonPropertiesGetRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Returns the key and value of an app\'s property.  **[Permissions](#permissions) required:** Only a Connect app whose key matches `addonKey` can make this request. Additionally, Forge apps can access Connect app properties (stored against the same `app.connect.key`).
     * Get app property
     */
    addonPropertiesResourceGetAddonPropertyGetRaw(requestParameters, initOverrides) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            if (requestParameters['addonKey'] == null) {
                throw new runtime.RequiredError('addonKey', 'Required parameter "addonKey" was null or undefined when calling addonPropertiesResourceGetAddonPropertyGet().');
            }
            if (requestParameters['propertyKey'] == null) {
                throw new runtime.RequiredError('propertyKey', 'Required parameter "propertyKey" was null or undefined when calling addonPropertiesResourceGetAddonPropertyGet().');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                // oauth required
                headerParameters["Authorization"] = yield this.configuration.accessToken("OAuth2", []);
            }
            if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
                headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
            }
            const response = yield this.request({
                path: `/rest/atlassian-connect/1/addons/{addonKey}/properties/{propertyKey}`.replace(`{${"addonKey"}}`, encodeURIComponent(String(requestParameters['addonKey']))).replace(`{${"propertyKey"}}`, encodeURIComponent(String(requestParameters['propertyKey']))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => (0, index_1.EntityPropertyFromJSON)(jsonValue));
        });
    }
    /**
     * Returns the key and value of an app\'s property.  **[Permissions](#permissions) required:** Only a Connect app whose key matches `addonKey` can make this request. Additionally, Forge apps can access Connect app properties (stored against the same `app.connect.key`).
     * Get app property
     */
    addonPropertiesResourceGetAddonPropertyGet(requestParameters, initOverrides) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const response = yield this.addonPropertiesResourceGetAddonPropertyGetRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Sets the value of an app\'s property. Use this resource to store custom data for your app.  The value of the request body must be a [valid](http://tools.ietf.org/html/rfc4627), non-empty JSON blob. The maximum length is 32768 characters.  **[Permissions](#permissions) required:** Only a Connect app whose key matches `addonKey` can make this request. Additionally, Forge apps can access Connect app properties (stored against the same `app.connect.key`).
     * Set app property
     */
    addonPropertiesResourcePutAddonPropertyPutRaw(requestParameters, initOverrides) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            if (requestParameters['addonKey'] == null) {
                throw new runtime.RequiredError('addonKey', 'Required parameter "addonKey" was null or undefined when calling addonPropertiesResourcePutAddonPropertyPut().');
            }
            if (requestParameters['propertyKey'] == null) {
                throw new runtime.RequiredError('propertyKey', 'Required parameter "propertyKey" was null or undefined when calling addonPropertiesResourcePutAddonPropertyPut().');
            }
            if (requestParameters['body'] == null) {
                throw new runtime.RequiredError('body', 'Required parameter "body" was null or undefined when calling addonPropertiesResourcePutAddonPropertyPut().');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.accessToken) {
                // oauth required
                headerParameters["Authorization"] = yield this.configuration.accessToken("OAuth2", []);
            }
            if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
                headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
            }
            const response = yield this.request({
                path: `/rest/atlassian-connect/1/addons/{addonKey}/properties/{propertyKey}`.replace(`{${"addonKey"}}`, encodeURIComponent(String(requestParameters['addonKey']))).replace(`{${"propertyKey"}}`, encodeURIComponent(String(requestParameters['propertyKey']))),
                method: 'PUT',
                headers: headerParameters,
                query: queryParameters,
                body: requestParameters['body'],
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => (0, index_1.OperationMessageFromJSON)(jsonValue));
        });
    }
    /**
     * Sets the value of an app\'s property. Use this resource to store custom data for your app.  The value of the request body must be a [valid](http://tools.ietf.org/html/rfc4627), non-empty JSON blob. The maximum length is 32768 characters.  **[Permissions](#permissions) required:** Only a Connect app whose key matches `addonKey` can make this request. Additionally, Forge apps can access Connect app properties (stored against the same `app.connect.key`).
     * Set app property
     */
    addonPropertiesResourcePutAddonPropertyPut(requestParameters, initOverrides) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const response = yield this.addonPropertiesResourcePutAddonPropertyPutRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Sets the value of a Forge app\'s property. These values can be retrieved in [Jira expressions](https://developer.atlassian.com/cloud/jira/platform/jira-expressions/) through the `app` [context variable](https://developer.atlassian.com/cloud/jira/platform/jira-expressions/#context-variables).  For other use cases, use the [Storage API](https://developer.atlassian.com/platform/forge/runtime-reference/storage-api/).  The value of the request body must be a [valid](http://tools.ietf.org/html/rfc4627), non-empty JSON blob. The maximum length is 32768 characters.  **[Permissions](#permissions) required:** Only Forge apps can make this request.
     * Set app property (Forge)
     */
    addonPropertiesResourcePutAppPropertyPutRaw(requestParameters, initOverrides) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            if (requestParameters['propertyKey'] == null) {
                throw new runtime.RequiredError('propertyKey', 'Required parameter "propertyKey" was null or undefined when calling addonPropertiesResourcePutAppPropertyPut().');
            }
            if (requestParameters['body'] == null) {
                throw new runtime.RequiredError('body', 'Required parameter "body" was null or undefined when calling addonPropertiesResourcePutAppPropertyPut().');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.accessToken) {
                // oauth required
                headerParameters["Authorization"] = yield this.configuration.accessToken("OAuth2", []);
            }
            if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
                headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
            }
            const response = yield this.request({
                path: `/rest/forge/1/app/properties/{propertyKey}`.replace(`{${"propertyKey"}}`, encodeURIComponent(String(requestParameters['propertyKey']))),
                method: 'PUT',
                headers: headerParameters,
                query: queryParameters,
                body: requestParameters['body'],
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => (0, index_1.OperationMessageFromJSON)(jsonValue));
        });
    }
    /**
     * Sets the value of a Forge app\'s property. These values can be retrieved in [Jira expressions](https://developer.atlassian.com/cloud/jira/platform/jira-expressions/) through the `app` [context variable](https://developer.atlassian.com/cloud/jira/platform/jira-expressions/#context-variables).  For other use cases, use the [Storage API](https://developer.atlassian.com/platform/forge/runtime-reference/storage-api/).  The value of the request body must be a [valid](http://tools.ietf.org/html/rfc4627), non-empty JSON blob. The maximum length is 32768 characters.  **[Permissions](#permissions) required:** Only Forge apps can make this request.
     * Set app property (Forge)
     */
    addonPropertiesResourcePutAppPropertyPut(requestParameters, initOverrides) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const response = yield this.addonPropertiesResourcePutAppPropertyPutRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
}
exports.AppPropertiesApi = AppPropertiesApi;
//# sourceMappingURL=AppPropertiesApi.js.map